import { createReducer, on } from '@ngrx/store';
import { News, PageData } from '../../models';
import * as pageActions from '../actions/news.action';
import * as utility from '../../../utility';

export interface NewsState {
  entities: { [id: number]: News };
  overview: { [id: number]: News };
  loaded: boolean;
  loading: boolean;
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
  page: PageData;
}

export const initialState: NewsState = {
  entities: {},
  overview: {},
  loaded: false,
  loading: false,
  overviewLoaded: false,
  overviewLoading: false,
  page: { current: 0, pageCount: 0, resultCount: 0, size: 12 },
};

export const NewsReducer = createReducer(
  initialState,
  on(pageActions.LoadNews, (state: NewsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadNewsSuccess, (state: NewsState, { news }) => {
    const entities = utility.ToEntities(news.items, 'id', {});
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadNewsFail, (state: NewsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.LoadNewsOverview, (state: NewsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(pageActions.LoadNewsOverviewSuccess, (state: NewsState, { news }) => {
    const overview = utility.ToEntities(news.items, 'id', {});
    return {
      ...state,
      overview,
      page: news.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadNewsOverviewFail, (state: NewsState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.LoadNewsDetail, (state: NewsState, { id }) => {
    const overview = { ...state.overview, [id]: { ...state.overview[id], loaded: false, loading: true } };
    return {
      ...state,
      overview,
    };
  }),
  on(pageActions.LoadNewsDetailSuccess, (state: NewsState, { news }) => {
    const overview = {
      ...state.overview,
      [news.id]: { ...news, loaded: true },
    };

    return {
      ...state,
      overview,
    };
  }),
  on(pageActions.ResetNews, (state: NewsState) => {
    return {
      ...state,
      overview: {},
      overviewLoaded: false,
      overviewLoading: false,
    };
  })
);

export const getNewsEntities = (state: NewsState) => state.entities;
export const getNewsLoading = (state: NewsState) => state.loading;
export const getNewsLoaded = (state: NewsState) => state.loaded;

export const getNewsOverviewEntities = (state: NewsState) => state.overview;
export const getNewsOverviewLoading = (state: NewsState) => state.overviewLoading;
export const getNewsOverviewLoaded = (state: NewsState) => state.overviewLoaded;
